import { cubicOut } from "svelte/easing";
export const customFade = function (node, { delay = 0, duration = 150, easing = cubicOut, start = 0, opacity = 0, beforeRender = null }) {
    const style = getComputedStyle(node);
    const target_opacity = +style.opacity;
    const od = target_opacity * (1 - opacity);
    const windowHeight = window.innerHeight;
    if (beforeRender) {
        const offsetX = beforeRender().adjustedOffsetX;
        const offsetY = beforeRender().adjustedOffsetY;
        node.style.setProperty("left", `${offsetX}px`);
        node.style.setProperty("top", `${offsetY}px`);
    }
    return {
        duration,
        easing,
        delay,
        tick: (t, u) => {
            if (beforeRender && node.getBoundingClientRect().bottom > windowHeight) {
                node.style.setProperty("top", `${beforeRender().adjustedOffsetY}px`);
            }
            node.style.setProperty("opacity", `${target_opacity - od * u}`);
        }
    };
};
